
import { Component, Input, OnInit } from '@angular/core';
import { Message, SelectItem } from 'primeng/api';
import { SelectableLab } from '../carrier/selectable-lab';
import { MasterDataService } from '../masterdata/masterdata.service';
import { ManufacturerPatterns } from '../masterdata/models/manufacturerPatterns';
import { Manufacturers } from '../masterdata/models/manufacturers';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';

@Component({
  selector: 'app-manufacturer-config',
  templateUrl: './manufacturer-config.component.html',
  styleUrls: ['./manufacturer-config.component.css']
})
export class ManufacturerConfigComponent implements OnInit {

  @Input() tableCols: any[];
  @Input() title: string;
  @Input() masterLists: Manufacturers[];
  @Input() selectedLab: SelectableLab;

  selectedMasterList: Manufacturers;
  displayMasterListDialog: boolean;
  typesOfMachines: SelectItem[] = [];
  messages: Message[] = [];
  patternsForManufacturer: ManufacturerPatterns[] = [];
  selectedPatterns: ManufacturerPatterns[] = [];
  manufacturerConfig: ManufacturerPatterns = new ManufacturerPatterns();
  isNewManufacturer: boolean;
  errorHandler: ErrorHandler = new ErrorHandler;
  private CSVVALUE:string="csv";
  disabledProcessType:boolean=true;

  // Dropdown values defination for manufacturer
  private roleOfFiles: SelectItem[] = [{ label: 'raw', value: 'raw' }, { label: 'result', value: 'result' },
  { label: 'xresult', value: 'xresult' }, { label: 'internal', value: 'internal' }];
  private processTypes: SelectItem[] = [{ label: 'Fasta 3x', value: 'fasta3x' }, { label: 'Fasta 4x', value: 'fasta4x' }];
  private fileTypes: SelectItem[] = [{ label: 'csv', value: 'csv' }, { label: 'adxd', value: 'adxd' }, { label: 'xlsx', value: 'xlsx' }, { label: 'txt', value: 'txt' },
  { label: 'pcrd', value: 'pcrd' }, { label: 'ixo', value: 'ixo' }, { label: 'zip', value: 'zip' }, { label: 'xml', value: 'xml' }, { label: 'json', value: 'json' }, { label: '*', value: '*' }];
  private fileSeparators: SelectItem[] = [{ label: 'comma', value: 'comma' }, { label: 'tab', value: 'tab' }, { label: 'semicolon', value: 'semicolon' }];
  private patternCols: any[] = [{ name: 'Pattern', column: 'pattern', colSpan: 2 }, { name: 'Role Of File', column: 'roleOfFile', colSpan: 1 }, { name: 'Process type', column: 'processTypes', colSpan: 1 },
  { name: 'File Type', column: 'fileType', colSpan: 1 }, { name: 'Separator', column: 'fileSeparator', colSpan: 1 }, { name: 'Mandatory', column: 'mandatory', colSpan: 1 }];

  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) { }

  ngOnInit() {
    this.messages = [];
    this.selectedMasterList = new Manufacturers();
    this.manufacturerConfig.pattern = '<batchID>';
    if(!this.masterLists || this.masterLists==null){
      this.masterLists = [];
    }
  }
  getTypesOfMachines() {
    this.typesOfMachines = [];
    this._masterDataService.getConfigList(this.selectedLab.lab._id, "machineType", 0, 100, true).subscribe(
      results => {
        if (!results  || !results.data.length) {
          this.messages.push({ severity: 'error', summary: 'No Machine Types!', detail: 'No machine types configured for the selected Lab', key:"cutom-toast" });
        }
      let isMachineTypePresent:boolean = false;
       results.data.forEach(element => {
        if(this.selectedMasterList.machineType && this.selectedMasterList.machineType == element.name.trim()){
          isMachineTypePresent = true;
        }
        this.typesOfMachines.push({ label: element.name.trim(), value: element.name.trim() });
      });
      if(!isMachineTypePresent && !this.isNewManufacturer){
        this.messages.push({ severity: 'warn', summary: 'Machine Type Missing!', detail: 'Selected machine type is not active please configure or change the machine type for manufacturer', key:"cutom-toast" });
      }
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);

      }
    );
  }
  selectManufacturer() {
    this.patternsForManufacturer = [];
    this.clearCache();
    this.displayMasterListDialog = true;
    this.isNewManufacturer = false;
    this.getTypesOfMachines();
    this.patternsForManufacturer = this.selectedMasterList.manufacturerConfigList;
  }
  addNewManufacturer() {
    this.patternsForManufacturer = [];
    this.isNewManufacturer = true;
    this.getTypesOfMachines();
    this.clearCache();
    this.selectedMasterList = new Manufacturers();
    this.displayMasterListDialog = true;
  }

  createPattern() {
    this.patternsForManufacturer.forEach(element => {
      if (element.pattern == this.manufacturerConfig.pattern && element.fileType == this.manufacturerConfig.fileType && element.roleOfFile == this.manufacturerConfig.roleOfFile 
        && element.processType == this.manufacturerConfig.processType) {
        this.messages.push({ severity: 'error', summary: 'Duplicate pattern', detail: 'same pattern is already added', key:"cutom-toast" });
        return;
      }
    });
    if (this.messages.length > 0) {
      return;
    }
    if (this.manufacturerConfig.fileType != this.CSVVALUE) {
      this.manufacturerConfig.fileSeparator = "";
    }
    this.patternsForManufacturer.push(this.manufacturerConfig);
    this.clearCache();
  }
  deletePattern() {
    this.selectedPatterns.forEach(pattern => {
      this.patternsForManufacturer.splice(this.patternsForManufacturer.indexOf(pattern), 1);
    });
    this.clearCache();
  }
  selectedRows() {
    return this.selectedPatterns.length <= 0;
  }
  saveButtonDisable() {
    return !(this.selectedMasterList.machineType  && this.selectedMasterList.manufacturerName && this.selectedMasterList.manufacturerName.trim() != "");
  }
  isCSVSelected(fileType: string) {
    return (fileType == this.CSVVALUE);
  }
  checkFileTypePresent(){
   if(this.manufacturerConfig.fileType == "csv"){
    return this.manufacturerConfig.fileSeparator;
   }
   return true;
  }
  checkCreatePattern() {
    return (!(this.manufacturerConfig.pattern && this.manufacturerConfig.pattern.trim() != "" 
            && this.manufacturerConfig.roleOfFile && this.manufacturerConfig.fileType && 
            this.checkFileTypePresent() && this.manufacturerConfig.roleOfFile!=="xresult" ) 
            && !(this.manufacturerConfig.processType && this.manufacturerConfig.processType.trim()!= "" 
            && this.manufacturerConfig.fileType && this.checkFileTypePresent()));
  }
  saveManufacturer() {
    this.selectedMasterList.manufacturerConfigList = this.patternsForManufacturer;
    if (this.isNewManufacturer) {
      this.selectedMasterList.lab = this.selectedLab.lab;
      this._masterDataService.saveConfig(this.selectedLab.lab, this.selectedMasterList, "machineManufacturer").subscribe(
        result => {
          if (!result) {
            return;
          }
          this.masterLists.push(result.data);
          this.displayMasterListDialog = false;
          this.isNewManufacturer = false;
          this._messageService.addSuccessMessage({
            severity: 'success', summary: 'Configuration saved',
            detail: 'Configuration ' + this.selectedMasterList.manufacturerName + ' has been successfully saved'
          });
        },
        error => {
          let message = this.errorHandler.handleError(error);
          message.key = "custom-toast";
          this.messages.push(message);
        }
      );
    } else {
      this._masterDataService.updateConfig(this.selectedLab.lab, this.selectedMasterList, "machineManufacturer").subscribe(
        result => {
          if (!result) {
            return;
          }
          this.masterLists[this.masterLists.indexOf(this.selectedMasterList)] = result.data;
          this.displayMasterListDialog = false;
          this._messageService.addSuccessMessage({
            severity: 'success', summary: 'Configuration updated',
            detail: 'Configuration ' + this.selectedMasterList.manufacturerName + ' has been successfully updated'
          });
        },
        error => {
          let message = this.errorHandler.handleError(error);
          message.key = "cutom-toast";
          this.messages.push(message);
        }
      );
    }
  }
  clearCache() {
    this.messages = [];
    this.manufacturerConfig = new ManufacturerPatterns();
    this.manufacturerConfig.pattern = '<batchID>';
    this.selectedPatterns = [];
  }

  onChange(event) {    
    if(event.value==="xresult"){
      this.disabledProcessType = false;
    }else{
      this.disabledProcessType = true;
      this.manufacturerConfig.processType = null;
    }
  }

}